import _classCallCheck from "/codebuild/output/src2989845404/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src2989845404/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * DevExtreme (esm/core/templates/template_base.js)
 * Version: 21.2.5
 * Build date: Mon Jan 17 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../renderer";
import domAdapter from "../dom_adapter";
import Callbacks from "../utils/callbacks";
import { contains } from "../utils/dom";
import { triggerShownEvent } from "../../events/visibility_change";
import errors from "../errors";
export var renderedCallbacks = Callbacks({
  syncStrategy: true
});
export var TemplateBase = /*#__PURE__*/function () {
  function TemplateBase() {
    _classCallCheck(this, TemplateBase);
  }

  _createClass(TemplateBase, [{
    key: "render",
    value: function render(options) {
      options = options || {};
      var onRendered = options.onRendered;
      delete options.onRendered;

      var $result = this._renderCore(options);

      this._ensureResultInContainer($result, options.container);

      renderedCallbacks.fire($result, options.container);
      onRendered && onRendered();
      return $result;
    }
  }, {
    key: "_ensureResultInContainer",
    value: function _ensureResultInContainer($result, container) {
      if (!container) {
        return;
      }

      var $container = $(container);
      var resultInContainer = contains($container.get(0), $result.get(0));
      $container.append($result);

      if (resultInContainer) {
        return;
      }

      var resultInBody = domAdapter.getBody().contains($container.get(0));

      if (!resultInBody) {
        return;
      }

      triggerShownEvent($result);
    }
  }, {
    key: "_renderCore",
    value: function _renderCore() {
      throw errors.Error("E0001");
    }
  }]);

  return TemplateBase;
}();